import { createReducer } from '../../store.model';

import { AddCommitmentNotesResult } from './state/add-commitment-notes.action';
import { addCommitmentNotesResultReducer } from './state/add-commitment-notes.reducer';
import {
    DeleteTranscriptQuotes,
    DeleteTranscriptQuotesResult,
} from './state/delete-transcript-quotes.action';
import {
    deleteTranscriptQuotesReducer,
    deleteTranscriptQuotesResultReducer,
} from './state/delete-transcript-quotes.reducer';
import { EditNotesFocus } from './state/edit-notes-focus.action';
import { editNotesFocusReducer } from './state/edit-notes-focus.reducer';
import { FilterQuotes } from './state/filter-quotes.action';
import { filterQuotesReducer } from './state/filter-quotes.reducer';
import { Reload, ReloadResult } from './state/reload.action';
import { reloadReducer, reloadResultReducer } from './state/reload.reducer';
import { ResetNav } from './state/reset-nav.action';
import { resetNavReducer } from './state/reset-nav.reducer';
import { Reset } from './state/reset.action';
import { resetReducer } from './state/reset.reducer';
import { SelectQuotes } from './state/select-quotes.action';
import { selectQuotesReducer } from './state/select-quotes.reducer';
import { SetNoteViaSummary } from './state/set-note-via-summary.action';
import { setNoteViaSummaryReducer } from './state/set-note-via-summary.reducer';
import { SwitchView } from './state/switch-view.action';
import { switchViewReducer } from './state/switch-view.reducer';
import {
    UpdateTranscript,
    UpdateTranscriptResult,
} from './state/update-transcript.action';
import {
    updateTranscriptReducer,
    updateTranscriptResultReducer,
} from './state/update-transcript.reducer';
import { ActionType } from './transcript-dialog.action';
import { defaultState, TranscriptDialogState } from './transcript-dialog.state';

const { builder, reducer } = createReducer<ActionType, TranscriptDialogState>(
    defaultState(),
);

builder.add<Reload>(ActionType.COACHING_DETAIL__TD__RELOAD, reloadReducer);
builder.add<ReloadResult>(
    ActionType.COACHING_DETAIL__TD__RELOAD_RESULT,
    reloadResultReducer,
);

builder.add<SetNoteViaSummary>(
    ActionType.COACHING_DETAIL__TD__SET_NOTE_VIA_SUMMARY,
    setNoteViaSummaryReducer,
);

builder.add<SwitchView>(
    ActionType.COACHING_DETAIL__TD__SWITCH_VIEW,
    switchViewReducer,
);

builder.add<FilterQuotes>(
    ActionType.COACHING_DETAIL__TD__FILTER_QUOTES,
    filterQuotesReducer,
);

builder.add<SelectQuotes>(
    ActionType.COACHING_DETAIL__TD__SELECT_QUOTES,
    selectQuotesReducer,
);

builder.add<UpdateTranscript>(
    ActionType.COACHING_DETAIL__TD__UPDATE_TRANSCRIPT,
    updateTranscriptReducer,
);
builder.add<UpdateTranscriptResult>(
    ActionType.COACHING_DETAIL__TD__UPDATE_TRANSCRIPT_RESULT,
    updateTranscriptResultReducer,
);

builder.add<Reset>(ActionType.COACHING_DETAIL__TD__RESET, resetReducer);

builder.add<DeleteTranscriptQuotes>(
    ActionType.COACHING_DETAIL__TD__DELETE_TRANSCRIPT_QUOTES,
    deleteTranscriptQuotesReducer,
);
builder.add<DeleteTranscriptQuotesResult>(
    ActionType.COACHING_DETAIL__TD__DELETE_TRANSCRIPT_QUOTES_RESULT,
    deleteTranscriptQuotesResultReducer,
);

builder.add<EditNotesFocus>(
    ActionType.COACHING_DETAIL__TD__EDIT_NOTES_FOCUS,
    editNotesFocusReducer,
);

builder.add<AddCommitmentNotesResult>(
    ActionType.COACHING_DETAIL__TD__ADD_COMMITMENT_NOTES_RESULT,
    addCommitmentNotesResultReducer,
);

builder.add<ResetNav>(
    ActionType.COACHING_DETAIL__TD__RESET_NAV,
    resetNavReducer,
);

export const transcriptDialogReducer = reducer;
